import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    Sorting,
    Editing,
    Export,
    Selection,
    Toolbar,
    Item,
    RequiredRule
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { confirm } from 'devextreme/ui/dialog';

import "../../../../css/omstyle.css";
import { Button } from 'devextreme-react';

import axios from "axios";
import routes from "../../../../../assets/apiRoutes.json";
import { MESSAGES } from "../../../../../common/Messages";
import RenderSelectBoxCell from "../../../../../common/RenderCell";
import DataSource from "devextreme/data/data_source";
import { buildDxFilters } from "../../../../../common/Utils";

const FreightTab = (props) => {
    const dataGrid = useRef(null);
    const [dataSources, setDataSources] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    useEffect(() => {
        const filters = buildDxFilters(
            { RTransactionHeader: props.formFields.ROWID },
            { RTransactionHeader: 'select' }
        );
        const store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.Freight.GetFreights}`,
            insertUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.Freight.AddFreight}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.Freight.EditFreight}`,
            loadParams: {
                filter: JSON.stringify(filters)
            },
            onBeforeSend(method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    Key: props.formFields.ROWID,
                };
            }
        });

        setDataSources(new DataSource({ store }));
    }, [props.formFields.ROWID]);


    const deleteRecords = useCallback(() => {
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.OM.Freight.Delete}`,
                        selectedItemKeys[0],
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }, [selectedItemKeys]);
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSources);
        }
    }
    const onRowInserting = (e) => {
        e.data.RTransactionHeader = props.formFields.ROWID;
    };
    const onCellClick = (e) => {
        if (e.rowType === "data" && e.data.RowId) {
            e.component.selectRows([e.data.RowId], false);
        }
    };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                dataSource={dataSources}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                onSelectionChanged={handleCellValueChanged}
                onRowInserting={onRowInserting}
                onCellClick={onCellClick}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                height='80vh'
            >
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <Column dataType="string" dataField="ShipmentId" caption="Shipment ID" />
                <Column dataType="number" dataField="Weight" caption="Weight" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataType="string" dataField="ChargeCode" caption="Charge Code" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "IDFreightCharge";
                            },
                            module: function () {
                                return "ID";
                            },
                            chargeTypes: function () {
                                return "S,F";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Name",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RCaActivity,
                        sort: [{ selector: "Name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.ChargeCode = newValue.text;
                        rowData.RChargeCode = newValue.value;
                    }} >
                    <RequiredRule message={MESSAGES.REQUIRED}></RequiredRule>
                </Column>
                <Column dataType="number" dataField="Amount" caption="Amount" format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} >
                </Column>

                <Column dataType="string" dataField="Comment" caption="Comment" />
                <Toolbar>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(FreightTab);